<template>
    <div class="company-list">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">


                    <div class="row">
                        <div class="col-xl-12">
                            <p class="p-title Raleway p-black"><b>We compare all power companies</b></p>
                            <p class="Raleway min-med p-dgrey">Our goal is to be the best at what we do. <b>TecknaEl.se</b> compares <b>143</b> Sweden's electricity trading companies. Click on a company for more information.</p>
                        </div>
                    </div>
                        <div class="row justify-content-end">
                        <div class="col-xl-4">
                            <div class="sort__blck">
                                <p class="Raleway med p-black mb-0"><b>Sort by:</b></p>
                                <div class="filter-blck filter-dropdown" v-click-outside="closetoogleshow4">
                                    <button class="btn btn-full btn-white small dropdown" @click="show4 = !show4">Fixed price 1 year</button>
                                    <transition name="fade">
                                        <div class="dropdown__el" v-if="show4">
                                            <div class="dropdown-list">
                                                <div class="dropdown-item">Fixed price 6 months</div>
                                                <div class="dropdown-item">Fixed price 6 months</div>
                                                <div class="dropdown-item">Fixed price 6 months </div>
                                                <div class="dropdown-item">Fixed price 6 months</div>
                                                <div class="dropdown-item">Fixed price 6 months</div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>

                        </div>
                    </div>
                    </div>
                    <!--this block may change with block on OneCompany.vue-->
                    <div class="company-items">
                        <div class="row">
                            <div class="col-md-6" v-for="companyItem in CompanyList">
                                <company-item :companyItem="companyItem" ></company-item>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="show-more p-center">
                                    <button class="btn btn-blue small"
                                            :class="{'load':preloaded}"
                                            :disabled="preloaded"
                                            @click="preloadBlock">
                                        Show more (Total: 95)
                                        <span v-if="preloaded">
                                            <img src="/img/tail-spin.svg" alt="">
                                        </span>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end this block may change with block on OneCompany.vue-->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import CompanyItem from "../Partials/companyItem"
    let companyList = [
        {
            id: 1,
            img: '/img/telinet.svg',
            title: 'Telinet Energi',
        },
        {
            id: 2,
            img: '/img/fortum.svg',
            title: 'Fortum',
        },
        {
            id: 3,
            img: '/img/telinet.svg',
            title: 'Telinet Energi',
        },
        {
            id: 4,
            img: '/img/fortum.svg',
            title: 'Fortum',
        },
        {
            id: 5,
            img: '/img/telinet.svg',
            title: 'Telinet Energi',
        },
        {
            id: 6,
            img: '/img/fortum.svg',
            title: 'Fortum',
        },
        {
            id: 7,
            img: '/img/telinet.svg',
            title: 'Telinet Energi',
        },
        {
            id: 8,
            img: '/img/fortum.svg',
            title: 'Fortum',
        },
        {
            id: 9,
            img: '/img/telinet.svg',
            title: 'Telinet Energi',
        },
        {
            id: 10,
            img: '/img/fortum.svg',
            title: 'Fortum',
        },

    ];

    export default {
        name: "CompanyList",
        components: {
            CompanyItem
        },
        data: function(){
            return {
                CompanyList: companyList,
                show4: false,
                preloaded: false,
            }
        },
        methods: {
            closetoogleshow4(){
                this.show4 = false
            },
            preloadBlock(){
                this.preloaded = true;
                let data = this;
                let delay = 2000;

                    setTimeout(function(){

                            data.preloaded = false;

                    }, delay);

            },
        }


    }
</script>